import { render, staticRenderFns } from "./Userhl_favideo_s.vue?vue&type=template&id=541a4845&"
import script from "./Userhl_favideo_s.vue?vue&type=script&lang=js&"
export * from "./Userhl_favideo_s.vue?vue&type=script&lang=js&"
import style0 from "./Userhl_favideo_s.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports